var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-top py-2"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"break-white-space"},[_vm._v(" "+_vm._s(_vm.data.content.Text.Text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }